import React from 'react';
import { BUSINESS_INFO } from '../data/mock';
import { analyticsService } from '../services/analyticsApi';
import { Search, FileCheck, Video, Truck, Gift, Shield, Heart, Euro, MessageCircle } from 'lucide-react';

export const DreamPuppySection = () => {
  const handleWhatsAppClick = () => {
    analyticsService.recordWhatsAppClick('dream-service', 'Cachorro de tus suenos', 'servicio');
    const message = encodeURIComponent(
      '¡Hola! Me interesa el servicio "Te busco el cachorro de tus sueños". ¿Podrían darme más información?'
    );
    window.open(`https://wa.me/34${BUSINESS_INFO.whatsapp}?text=${message}`, '_blank');
  };

  const services = [
    {
      icon: Search,
      title: 'Selección personalizada',
      description: 'Selección de raza, perfil y sexo según tus preferencias'
    },
    {
      icon: FileCheck,
      title: 'Red global de criaderos',
      description: 'Búsqueda en nuestra red global de criaderos élite y socios'
    },
    {
      icon: Shield,
      title: 'Pedigree opcional',
      description: 'Pedigree opcional previo encargo (varía el precio) o reconocimiento de raza +85€'
    },
    {
      icon: Video,
      title: 'Visita virtual o presencial',
      description: 'Coordinación de visita virtual, por videos o presencial del cachorro (si es posible)'
    },
    {
      icon: Truck,
      title: 'Gestión del transporte',
      description: 'Gestión completa de documentación y transporte a nuestro centro canino'
    },
    {
      icon: Gift,
      title: 'Entrega con kit de lujo',
      description: 'Entrega personal del cachorro con kit de cachorro de lujo incluido'
    },
    {
      icon: Heart,
      title: 'Garantía de salud',
      description: 'Garantía de 15 días vírica extendida + soporte post-venta 6 meses congénita. Adjunto contrato'
    },
    {
      icon: FileCheck,
      title: 'Gestión completa',
      description: 'Me encargo de todo el proceso de búsqueda y asesoramiento en la elección'
    }
  ];

  return (
    <section className="bg-gradient-to-br from-amber-100 via-orange-50 to-amber-50 rounded-3xl p-8 mb-10 border-2 border-amber-200 shadow-xl">
      {/* Header */}
      <div className="text-center mb-8">
        <p className="text-amber-700 font-medium text-lg mb-2">SI NO LO TENEMOS...</p>
        <h2 className="text-3xl md:text-4xl font-bold text-amber-900 mb-4">
          🐶 TE BUSCO EL CACHORRO DE TUS SUEÑOS
        </h2>
        <p className="text-amber-700 max-w-2xl mx-auto">
          Servicio exclusivo de búsqueda personalizada del cachorro perfecto para ti
        </p>
      </div>

      {/* Services Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {services.map((service) => (
          <div 
            key={service.title}
            className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-all duration-300 border border-amber-100"
          >
            <service.icon className="w-8 h-8 text-amber-600 mb-3" />
            <h3 className="font-semibold text-amber-900 mb-1">{service.title}</h3>
            <p className="text-sm text-amber-700">{service.description}</p>
          </div>
        ))}
      </div>

      {/* Reservation Info */}
      <div className="bg-white rounded-2xl p-6 mb-6 border border-amber-200">
        <div className="flex items-start gap-3 mb-4">
          <Euro className="w-6 h-6 text-amber-600 mt-1 flex-shrink-0" />
          <div>
            <h3 className="font-bold text-amber-900 text-lg">Reserva de encargo previa búsqueda de tu cachorro: 250€</h3>
            <p className="text-amber-700 mt-1">* 50€ de gestión</p>
          </div>
        </div>
        
        <div className="bg-amber-50 rounded-xl p-4 border border-amber-100">
          <h4 className="font-semibold text-amber-900 mb-2">📋 Condiciones de la reserva:</h4>
          <ul className="text-amber-700 space-y-2 text-sm">
            <li>✅ Si encontramos el cachorro perfecto y están conformes, procedemos con la compra</li>
            <li>↩️ En caso contrario, se devuelve la reserva menos 50€ por gastos de gestión</li>
          </ul>
        </div>
      </div>

      {/* CTA Button */}
      <div className="text-center">
        <button
          onClick={handleWhatsAppClick}
          className="inline-flex items-center gap-3 bg-emerald-500 text-white px-8 py-4 rounded-2xl font-bold text-lg hover:bg-emerald-600 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
        >
          <MessageCircle className="w-6 h-6" />
          ¡Quiero mi cachorro soñado!
        </button>
        <p className="text-amber-600 mt-3 text-sm">
          Contáctanos por WhatsApp para más información
        </p>
      </div>
    </section>
  );
};
